var exports = {
  "wx": "header__cF8jf8",
  "qd": "headerTitle__84GFfT",
  "kL": "container__HYT1j8",
  "Ow": "icebreaker__scutDl",
  "P0": "iconWrapper__1gc-T5",
  "P_": "textContent__z_RL-p",
  "DD": "title__EG2SKV",
  "m_": "subheader__kS7Ugd",
};

module.exports = exports;
